module.exports = ".selector.collapse {\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/employee-registration/employee-registration.component.scss
// module id = ./src/app/admin/employee-registration/employee-registration.component.scss
// module chunks = main